import React, { FC, useState } from "react";
import { CheckoutResponse, LCSkuType, SaleorMetadata, TranslationData } from "@/common/lib/types";
import Button from "@/components/ui/button/Button";
import { metadataKeys, metadataValues } from "../resource/config";
import { getClientCookie } from "@/utils/common";
import { localeConstants } from "@/apiUtils/constants";
import { getLangFromLocale } from "@/utils/common";
import PairEyewearTopModal from "@/components/pairEyewear/PairEyewearTopModal";
import { PairEyewearTopsContent } from "@/common/lib/types";

interface AddToCartProps {
  children: React.ReactNode;
  isPairEyewear: boolean;
  isBundle?: boolean;
  onCloseLensConfigurator?: () => void;
  translations: TranslationData;
  model: string;
  brand: string;
  variantId?: string;
  handleAddToCart?: (
    id: string,
    addOnSkus?: LCSkuType,
    prescription?: string,
    metadata?: SaleorMetadata[],
  ) => Promise<{
    success: boolean;
    cartCount: number;
    response: CheckoutResponse;
  }>;
  pairEyewearTopsContent?: PairEyewearTopsContent | null;
}

const AddToCart: FC<AddToCartProps> = ({ handleAddToCart, children, isPairEyewear, isBundle = false, onCloseLensConfigurator, translations, model, brand, variantId, pairEyewearTopsContent = null }) => {
  const [disable, setDisable] = useState(false);
  const [isOpen, setIsOpen] = React.useState<boolean>(false);

  const locale = getClientCookie(localeConstants.NEXT_LOCALE) || "";
  const lang = getLangFromLocale(locale) as "en" | "ar";

  const handleLocalAddToCart = async () => {
    if (!handleAddToCart) return;

    setDisable(true);
    await handleAddToCart("", undefined, undefined, [
      { key: metadataKeys.FRAME_ONLY, value: metadataValues.FRAME_ONLY },
    ]);

    if (isPairEyewear && !isBundle) {
      setIsOpen(true);
    } else {
      if (typeof onCloseLensConfigurator === "function") {
        onCloseLensConfigurator();
      }
    }
  };

  const handleClose = () => {
    setIsOpen(false);
    if (typeof onCloseLensConfigurator === "function") {
      onCloseLensConfigurator();
    }
  };
  return (
    <>
      <Button
        disabled={disable}
        onClick={handleLocalAddToCart}
        className="px-3 py-1 sm:px-3 sm:py-1 md:px-3 md:py-1"
      >
        {children}
      </Button>
      {isPairEyewear && (
        <PairEyewearTopModal
          isOpen={isOpen}
          onClose={handleClose}
          pairEyewearTopsContent={pairEyewearTopsContent}
          translations={translations}
          locale={locale}
          missingTopModel={[{ model }]}
          variantIdsToExcludeFromAddedCount={variantId ? [variantId] : undefined}
        />
      )}
    </>
  );
};

export default AddToCart;
